import Templates from './Templates';
import TemplatesController from './TemplatesController';

export { Templates };

export default TemplatesController;
